import {
    SYNC_UPDATE_NEWS_HASH,
    SYNC_UPDATE_ADS_TIMESTAMP,
    SYNC_UPDATE_TWITCH_STATUS,
    SYNC_UPDATE_BACKGROUND,
    SYNC_UPDATE_VERSIONS,
    SYNC_UPDATE_HASH,
} from '../constants'

export function actionNewsUpdateHash(hash) {
    return {
        type: SYNC_UPDATE_NEWS_HASH,
        payload: hash,
    }
}

export function actionAdsUpdateTimestamp(timestamp) {
    return {
        type: SYNC_UPDATE_ADS_TIMESTAMP,
        payload: timestamp,
    }
}

export function actionTwitchUpdateStatus(status) {
    return {
        type: SYNC_UPDATE_TWITCH_STATUS,
        payload: status,
    }
}

export function actionVersionUpdate(versions) {
    return {
        type: SYNC_UPDATE_VERSIONS,
        payload: versions,
    }
}

export function actionBackgroundUpdate(background) {
    return {
        type: SYNC_UPDATE_BACKGROUND,
        payload: background,
    }
}

export function actionSyncUpdateHash(hash) {
    return {
        type: SYNC_UPDATE_HASH,
        payload: hash,
    }
}



// WEBPACK FOOTER //
// ./src/actions/sync.js